import { PLAYER_SIZE } from './gameConstants';

export const GameHUD = ({ selectedCharacter, score, coins, lives, currentLevel, levelNames, isMusicOn, toggleMusic, balloonBoostActive, isSlowing, isDiving, gameMode, aiPlayersDisplay }) => {
  return (
    <>
      <div className="absolute top-3 left-3 text-white" data-testid="player-overlay">
        <div className="flex items-center gap-2 mb-1">
          {selectedCharacter && (
            <div className="w-6 h-6 rounded-full border-2 overflow-hidden" style={{ borderColor: selectedCharacter.color }}>
              <img src={selectedCharacter.png} alt="" className="w-full h-full object-contain" />
            </div>
          )}
          <span className="game-score text-sm" data-testid="player-name">
            {selectedCharacter ? selectedCharacter.name : 'Mimi'}
          </span>
        </div>
        <div className="game-score text-xl" data-testid="current-score">Score: {score}</div>
        <div className="game-score text-sm">Coins: {coins}</div>
        <div className="game-score text-sm" data-testid="player-lives">
          Lives: {Array.from({ length: 3 }, (_, i) => (
            <span key={i} style={{ opacity: i < lives ? 1 : 0.25 }}>
              {i < lives ? '\u2764\uFE0F' : '\u{1F5A4}'}
            </span>
          ))}
        </div>
        <div className="game-score text-xs mt-1 opacity-70">
          {levelNames[currentLevel]}
        </div>
      </div>

      {/* Music Toggle */}
      <div className="absolute top-4 right-4">
        <button
          onClick={(e) => { e.stopPropagation(); toggleMusic(); }}
          className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full shadow-lg transition-all hover:scale-110 active:scale-95"
          data-testid="music-toggle"
          title={isMusicOn ? 'Music On' : 'Music Off'}
        >
          <span className="text-2xl">{isMusicOn ? '🔊' : '🔇'}</span>
        </button>
      </div>

      {/* Balloon Boost Indicator */}
      {balloonBoostActive && (
        <div className="absolute top-16 right-4 bg-purple-500/80 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse"
          data-testid="boost-indicator" style={{ fontFamily: 'Fredoka, sans-serif' }}>
          🎈 BOOST!
        </div>
      )}

      {/* Slow-down Indicator */}
      {isSlowing && (
        <div className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-blue-500/70 backdrop-blur-sm text-white px-4 py-1 rounded-full text-xs font-bold"
          data-testid="slow-indicator" style={{ fontFamily: 'Fredoka, sans-serif' }}>
          SLOW MODE
        </div>
      )}

      {/* Dive Indicator */}
      {isDiving && (
        <div className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-orange-500/70 backdrop-blur-sm text-white px-4 py-1 rounded-full text-xs font-bold"
          data-testid="dive-indicator" style={{ fontFamily: 'Fredoka, sans-serif' }}>
          DIVE
        </div>
      )}

      {/* AI Stats Overlay */}
      {gameMode === 'fakeOnline' && aiPlayersDisplay.length > 0 && (
        <div className="absolute top-3 right-14 flex flex-col gap-1" data-testid="ai-overlay">
          {aiPlayersDisplay.map((ai) => (
            <div key={ai.id}
              className="flex items-center gap-1 bg-black/30 backdrop-blur-sm rounded-lg px-2 py-1"
              style={{ borderLeft: `3px solid ${ai.color}` }}>
              <div className="w-4 h-4 rounded-full overflow-hidden flex-shrink-0">
                <img src={ai.png} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="text-white" style={{ fontFamily: 'Fredoka, sans-serif' }}>
                <span className="text-xs font-bold">{ai.name}</span>
                <span className="text-xs ml-1 opacity-80">{ai.score}</span>
                <span className="text-xs ml-1">
                  {Array.from({ length: 3 }, (_, i) => (
                    <span key={i} style={{ fontSize: '8px', opacity: i < ai.lives ? 1 : 0.25 }}>
                      {i < ai.lives ? '\u2764' : '\u25CB'}
                    </span>
                  ))}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
